<template>
  <component
    v-bind="props"
    :is="component"
    v-if="component"
    @confirm="confirm"
    @close="close"
    @on-cancel="cancel"
  />
</template>

<script>
export default {
  name: 'DynamicDialog',
  props: {
    // The component to render as the dialog
    component: {
      type: [Object, Function],
      required: true,
    },
    // Props to be bound to the component
    props: {
      type: Object,
      required: true,
    },
  },
  methods: {
    close() {
      window.requestAnimationFrame(() => {
        // eslint-disable-next-line vue/no-mutating-props
        this.component = null;
        this.$destroy();
        this.$el.remove();
      });
    },
    cancel() {
      this.close();
      this.onCancel?.();
    },
    confirm() {
      this.close();
      this.onConfirm?.();
    },
  },
};
</script>
